export const emailTypes = Object.freeze({
    RECEIVED: "RECEIVED",
    SENT: "SENT",
});
